module.exports = __webpack_public_path__ + "files/f7f25d7a9cf13e9f7c22813c6469828c.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-italic-webfont.woff
 ** module id = 894
 ** module chunks = 0
 **/